/// <amd-module name="MarkdownEditor/Components/MarkdownTabBar" />
import { IMarkdownTabBarProps } from "MarkdownEditor/Components/MarkdownTabBar.Props";
import { Markdown, Preview } from "MarkdownEditor/Resources";
import * as React from "react";
import { Tab, TabBar, TabSize } from "VSSUI/Tabs";

export class MarkdownTabBar extends React.PureComponent<IMarkdownTabBarProps, {}> {
    public render(): JSX.Element {
        const { togglePreview, selectedTab } = this.props;

        return (
            <div className="flex-row flex-center markdown-component-tabs-container">
                <TabBar
                    className="markdown-component-tabs"
                    tabSize={TabSize.Compact}
                    selectedTabId={selectedTab}
                    onSelectedTabChanged={togglePreview}
                >
                    <Tab name={Markdown} id="edit" />
                    <Tab name={Preview} id="preview" />
                </TabBar>
            </div>
        );
    }
}
